var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 162,
    viewBox: "0 0 205 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_316_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37672 129.205C3.21514 129.083 1.99243 129.449 1.13653 130.303C-0.391863 131.828 -0.391863 134.268 1.13653 135.793C1.99243 136.647 3.21514 137.013 4.37672 136.891C5.53829 137.013 6.76101 136.647 7.6169 135.793C9.14529 134.268 9.14529 131.828 7.6169 130.303C6.69987 129.449 5.53829 129.083 4.37672 129.205Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5428 84.4648C13.3027 84.4648 10.6738 87.088 10.6738 90.3211C10.6738 93.5543 13.3027 96.1774 16.5428 96.1774C19.783 96.1774 22.4119 93.5543 22.4119 90.3211C22.4119 87.088 19.7708 84.4648 16.5428 84.4648Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.186 74.0586C192.907 74.0586 189.373 77.5358 189.373 81.8548C189.373 86.186 192.858 89.651 197.186 89.651C201.466 89.651 204.999 86.1738 204.999 81.8548C204.999 77.5358 201.515 74.0586 197.186 74.0586Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.36 33.2461C181.524 33.2461 183.273 34.9908 183.273 37.1503C183.273 39.3098 181.524 41.0545 179.36 41.0545C177.196 41.0545 175.447 39.3098 175.447 37.1503C175.447 34.9908 177.196 33.2461 179.36 33.2461Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6783 0C60.8425 0 62.591 1.74469 62.591 3.9042C62.591 6.06371 60.8425 7.8084 58.6783 7.8084C56.5141 7.8084 54.7656 6.06371 54.7656 3.9042C54.7656 1.74469 56.5141 0 58.6783 0Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.051 140.271C180.216 140.271 181.964 142.016 181.964 144.176C181.964 146.335 180.216 148.08 178.051 148.08C175.887 148.08 174.139 146.335 174.139 144.176C174.139 142.028 175.887 140.271 178.051 140.271Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.565 51.4375C17.7292 51.4375 19.4777 53.1822 19.4777 55.3417C19.4777 57.5012 17.7292 59.2459 15.565 59.2459C13.4008 59.2459 11.6523 57.5012 11.6523 55.3417C11.6523 53.1822 13.4008 51.4375 15.565 51.4375Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.381 125.74C194.546 125.74 196.294 127.485 196.294 129.644C196.294 131.804 194.546 133.549 192.381 133.549C190.217 133.549 188.469 131.804 188.469 129.644C188.469 127.485 190.229 125.74 192.381 125.74Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3372 44.873H74.1328V66.3828H82.3372V44.873Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2283 47.1191H66.7969V66.3717H73.2283V47.1191Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1985 44.873H61.6133V66.3828H66.1985V44.873Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7621 44.0312H40.4844V66.3706H48.7621V44.0312Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.678 47.5449H50.498V66.3705H58.678V47.5449Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.911 41.543H101.301V66.3835H110.911V41.543Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.129 56.5371H123.592V66.383H133.129V56.5371Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.301 102.217H114.764V112.063H124.301V102.217Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8646 50.877H84.3301V66.384H92.8646V50.877Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.013 40.9453H144.488V66.3836H154.013V40.9453Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.666 48.3633H135.061V66.3714H142.666V48.3633Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7824 47.1191H94.5273V66.3717H98.7824V47.1191Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.004 46.6914V48.1189H113.162V66.3832H122.76V46.6914H118.004Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.712 13.3594H26.765C24.8576 13.3594 23.2559 15.0187 23.2559 17.0318V23.8519C23.2559 25.8528 24.8576 27.5243 26.765 27.5243H29.9441V159.755V162H32.1205H164.381H166.558V159.755V27.5365H169.725C171.669 27.5365 173.246 25.865 173.246 23.8641V17.044C173.234 15.0187 171.656 13.3594 169.712 13.3594ZM162.193 157.51H161.398H159.87H152.362H150.76H146.004H144.916H128.275H127.7H121.281H119.936H115.106H112.917H107.99H106.156H96.5452H96.1417H91.8745H91.7889H75.8936H74.7321H68.215H67.7137H63.0307H61.9547H53.7503H52.2586H44.0664H43.6507H35.3852H34.6026H34.3581V119.163H162.193V157.51ZM162.193 112.062H160.799H159.527H151.946H150.418H145.674H144.573H134.963H105.801H96.1907H95.7872H91.5321H91.4343H82.8142H79.3417H67.8726H67.298H62.6883H59.7661H51.5739H49.8132H41.5476H37.0114H34.3581V73.3865H162.193V112.062ZM162.193 66.3833H157.424H154.013H144.488H142.666H135.061H133.129H123.592H122.772H113.174H110.924H101.314H98.795H94.54H92.8771H84.3426H82.3496H74.1452H73.2403H66.8089H66.2098H61.6246H58.6901H50.4979H48.7494H40.4716H37.904H34.3581V27.5365H162.193V66.3833Z",
    fill: "#3733BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4346 96.3105H82.8145V112.062H91.4346V96.3105Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3167 90.8208V88.0391H67.873V112.062H79.3421V90.8208H74.3167Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2971 94.6406H62.6875V112.063H67.2971V94.6406Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8124 98.2266H41.5469V112.062H49.8124V98.2266Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7664 90.9668H51.5742V112.062H59.7664V90.9668Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.418 93.2246H145.674V112.062H150.418V93.2246Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.528 90.7227H151.947V112.074H159.528V90.7227Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.573 88.4668H134.963V112.063H144.573V88.4668Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7863 93.8965H91.5312V112.075H95.7863V93.8965Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.802 88.7109H96.1914V112.075H105.802V88.7109Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7202 132.512H68.2031V157.511H74.7202V132.512Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1286 138.428H91.8613V157.51H96.1286V138.428Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0867 140.832V135.488H75.8945V157.51H91.7653V140.832H84.0867Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7006 139.086H63.0176V157.509H67.7006V139.086Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6503 147.664H35.3848V157.498H43.6503V147.664Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2586 139.086H44.0664V157.509H52.2586V139.086Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9544 134.816H53.75V157.51H61.9544V134.816Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.144 133.17H96.5332V157.498H106.144V133.17Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.306 132.998V139.904H128.275V157.509H144.917V132.998H135.306Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.869 135.158H152.361V157.51H159.869V135.158Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.76 137.758H146.004V157.511H150.76V137.758Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.687 141.16H121.268V157.509H127.687V141.16Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.923 136.5H115.094V157.51H119.923V136.5Z",
    fill: "#F99E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.906 143.516H107.979V157.51H112.906V143.516Z",
    fill: "#F99E1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_316_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 162,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnf);
export default __webpack_public_path__ + "static/media/sınıf.706dda3469569c6e73797de3aa2ab242.svg";
export { ForwardRef as ReactComponent };